interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "SCR";
};

const SCR: Currency = Object.freeze({
  "displayName": "Seychelles Rupee",
  "numericCode": 690,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "SCR",
  "symbol": "₨"
});

export { SCR };
